export const ONE_HOUR_IN_MS = 60 * 60 * 1000; //used by ReactQuery staleTime
